const MENU_CLASS = 'dropdown-menu';
const OPENED_MENU_CLASS = 'main-nav__link--dropdown-open';
const navList = document.querySelector('.main-nav__list');
let openedMenu = null;

function toggleMenuClass(el) {
  el.classList.toggle(OPENED_MENU_CLASS);
  if (openedMenu !== null) {
    if (openedMenu == el) {
      openedMenu = null;
    } else {
      const closingMenu = openedMenu.parentNode.querySelector(`.${OPENED_MENU_CLASS}`);
      closingMenu.classList.remove(OPENED_MENU_CLASS);
      openedMenu = el;
    }
  } else {
    openedMenu = el;
  }
}

navList.addEventListener('click', (e) => {
  const target = e.target;
  if (target.dataset.name && target.dataset.name === 'dropdown') {
    toggleMenuClass(target);
  }
});
